import { ISelectStaffTypeOption } from './EmploymentStatusesTypeSelectInput.types';
import i18next from 'i18next';

export const employmentStatusesTypeDropdownOptions = (): ISelectStaffTypeOption[] => [
  {
    key: 'internal_full_time',
    value: 'internal_full_time',
    label: i18next.t('dashboard:INTERNAL_FULL_TIME'),
    name: 'internalJaneType',
  },
  {
    key: 'internal_part_time',
    value: 'internal_part_time',
    label: i18next.t('dashboard:INTERNAL_PART_TIME'),
    name: 'internalJaneType',
  },
  {
    key: 'internal_casual',
    value: 'internal_casual',
    label: i18next.t('dashboard:INTERNAL_CASUAL'),
    name: 'internalJaneType',
  },
  {
    key: 'flex',
    value: 'flex',
    label: i18next.t('dashboard:FLEX'),
    name: 'internalJaneType',
  },
];
